import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subject } from 'rxjs';
import { FormHelperService } from '../../../helpers/form-helper.service';
import { HOME_PHONE_NUMBER_REGEX, isNullOrWhiteSpace, MOBILE_PHONE_NUMBER_REGEX } from '@classifieds-sell/shared';
import { DraftFacade } from '@classifieds-sell/state';
import { PropertySectionBase } from '../../property-section-base';

@Component({
    selector: 'property-contact-details-section',
    templateUrl: './property-contact-details-section.component.html',
    styleUrls: ['./property-contact-details-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PropertyContactDetailsSectionComponent
    extends PropertySectionBase
    implements OnInit, OnDestroy {
    private _destroyed$: Subject<void> = new Subject<void>();

    @ViewChild('propertyContactDetailsSectionForm')
    propertyContactDetailsSectionForm: NgForm;

    homePhoneNumberRegex: string = HOME_PHONE_NUMBER_REGEX;
    mobilePhoneNumberRegex: string = MOBILE_PHONE_NUMBER_REGEX;

    initiated = false;

    hasErrorInAgentDetails = false;

    values: Record<string, string | number | null> = {
        landLine: null,
        mobile: null,
        contactTime: null,
        agentAgency: null,
        agentName: null,
        agentMobile: null,
        agentLandLine: null,
        agentEmail: null
    };

    constructor(
        public draftFacade: DraftFacade,
        private changeDetectorRef: ChangeDetectorRef,
        private formHelperService: FormHelperService
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            if (!this.initiated) {
                this.values.landLine =
                    this.draftData.propertyInformation.landLine;
                this.values.mobile =
                    this.draftData.propertyInformation.mobile;
                this.values.contactTime =
                    this.draftData.propertyInformation.contactTimes;

                this.values.agentAgency =
                    this.draftData.propertyInformation.agentAgency;
                this.values.agentName =
                    this.draftData.propertyInformation.agentName;
                this.values.agentMobile =
                    this.draftData.propertyInformation.agentMobile;
                this.values.agentLandline =
                    this.draftData.propertyInformation.agentLandLine;
                this.values.agentEmail =
                    this.draftData.propertyInformation.agentEmail;
                this.initiated = true;
            }

            this.changeDetectorRef.markForCheck();
        });
    }

    isValid(): boolean {
        this.hasErrorInAgentDetails = false;

        this.formHelperService.validate(this.propertyContactDetailsSectionForm);
        const validationResult = this.validate();
        this.changeDetectorRef.markForCheck();
        return (
            this.propertyContactDetailsSectionForm.form.valid &&
            validationResult
        );
    }

    dirty(): boolean {
        return this.propertyContactDetailsSectionForm.form.dirty;
    }

    onIsPropertyAgentChange(value: boolean) {
        if (!value) {
            this.draftData.propertyInformation.name = null;
            this.draftData.propertyInformation.agency = null;
        }
        this.publish();
    }

    onShouldContactAgentChange(value: boolean) {
        this.draftData.propertyInformation.landLine = !value
            ? this.values.landLine
            : null;
        this.draftData.propertyInformation.mobile = !value
            ? this.values.mobile
            : null;
        this.draftData.propertyInformation.contactTimes = !value
            ? this.values.contactTime
            : null;

        this.draftData.propertyInformation.agentAgency = value
            ? this.values.agentAgency
            : null;
        this.draftData.propertyInformation.agentName = value
            ? this.values.agentName
            : null;
        this.draftData.propertyInformation.agentMobile = value
            ? this.values.agentMobile
            : null;
        this.draftData.propertyInformation.agentLandLine = value
            ? this.values.agentLandline
            : null;
        this.draftData.propertyInformation.agentEmail = value
            ? this.values.agentEmail
            : null;
        this.publish();
    }

    onSelectChange(value: number, name: string) {
        this.values[name] = value;
    }

    onInputChange(value: string, name: string) {
        this.values[name] = value;
    }

    private validate(): boolean {
        if (
            this.draftData.propertyInformation.shouldContactAgent &&
            isNullOrWhiteSpace(
                this.draftData.propertyInformation.agentMobile
            ) &&
            isNullOrWhiteSpace(
                this.draftData.propertyInformation.agentLandLine
            ) &&
            isNullOrWhiteSpace(this.draftData.propertyInformation.agentEmail)
        ) {
            this.hasErrorInAgentDetails = true;
            return false;
        }

        return true;
    }

    onAgentDetailChange() {
        this.hasErrorInAgentDetails = false;
        this.publish();
    }
}
